const SERIES_RE = /\d[\d\s,]+\d[\d\s,]+\d/;
const FORMULA_RE = /[@#\^]|\([^)]*[+\-*/][^)]*\)/;
const SEQUENCE_RE = /[A-Z],\s*[A-Z],\s*[A-Z]/;
const OPERATOR_RE = /\bif\s+\w+\s*[@#$&]\s*\w+\s*=/i;

const PASSAGE_SIGNALS = [
  'according to the passage',
  'according to the given passage',
  'read the following passage',
  'read the passage',
  'read the information given below',
  'based on the following',
  'refer to the passage'
];

const STEM_PREFIXES = [
  'find the value of',
  'what is the value of',
  'which of the following',
  'find the missing',
  'what comes next',
  'the value of',
  'find the next',
  'choose the correct',
  'identify the',
  'which option',
  'what will be',
  'how many',
  'what is',
  'find the'
];

function splitStructured(text) {
  const sentences = text
    .split(/(?<=[.?])\s+/)
    .map((s) => s.trim())
    .filter(Boolean);

  if (sentences.length <= 1) {
    return { premise: null, dataBlock: null, questionStem: text };
  }

  let stemIdx = sentences.length - 1;
  for (let i = sentences.length - 1; i >= 0; i -= 1) {
    const normalized = sentences[i].toLowerCase();
    if (sentences[i].includes('?') || STEM_PREFIXES.some((prefix) => normalized.startsWith(prefix))) {
      stemIdx = i;
      break;
    }
  }

  const questionStem = sentences[stemIdx];
  const beforeStem = sentences.slice(0, stemIdx);

  if (!beforeStem.length) {
    return { premise: null, dataBlock: null, questionStem };
  }

  let dataStartIdx = -1;
  for (let i = 0; i < beforeStem.length; i += 1) {
    const part = beforeStem[i];
    if (SERIES_RE.test(part) || FORMULA_RE.test(part) || SEQUENCE_RE.test(part) || OPERATOR_RE.test(part)) {
      dataStartIdx = i;
      break;
    }
  }

  if (dataStartIdx === -1) {
    return {
      premise: beforeStem.join(' '),
      dataBlock: null,
      questionStem
    };
  }

  return {
    premise: beforeStem.slice(0, dataStartIdx).join(' ') || null,
    dataBlock: beforeStem.slice(dataStartIdx).join('\n'),
    questionStem
  };
}

export function parseQuestionStructure(rawQuestion) {
  if (!rawQuestion || typeof rawQuestion !== 'string') {
    return { type: 'simple', text: '' };
  }

  const text = rawQuestion.trim();
  const lower = text.toLowerCase();

  if (PASSAGE_SIGNALS.some((signal) => lower.includes(signal))) {
    const qMarkIdx = text.lastIndexOf('?');
    const stemStart = Math.max(0, qMarkIdx - 120);
    const before = text.slice(0, stemStart).trim();
    const stem = text.slice(stemStart).trim();

    return {
      type: 'passage',
      passageText: before || text,
      questionStem: stem || text
    };
  }

  const hasDataSignals = SERIES_RE.test(text) || FORMULA_RE.test(text) || SEQUENCE_RE.test(text) || OPERATOR_RE.test(text);
  if (hasDataSignals) {
    const { premise, dataBlock, questionStem } = splitStructured(text);
    return { type: 'structured', premise, dataBlock, questionStem };
  }

  return { type: 'simple', text };
}

export function formatDataBlock(dataBlock) {
  if (!dataBlock) return '';
  if (/^[\d\s,?_x.()]+$/.test(dataBlock)) {
    return dataBlock
      .split(',')
      .map((s) => s.trim())
      .join('  ·  ');
  }
  return dataBlock;
}
